"use client"
import {
  Menu,
  MenuDivider,
  MenuDropdown,
  MenuLabel,
  MenuTarget,
} from "@mantine/core"

import { BlueButton } from "@/components/generic/BlueButton"
import { MenuItemInstallExtensionButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/MenuItemInstallExtensionButton"
import { MenuItemInstallMobileAppButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/MenuItemInstallMobileAppButton"
import { useAppStore } from "@/app/(store)/appStore"
import { getDJUIServerFeatureStatus } from "@/lib/featureFlags.utils"
import { MenuItemToggleDJUIButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/MenuItemToggleDJUIButton"
import dynamic from "next/dynamic"

const UserProfileImageWithUserStatus = dynamic(
  () =>
    import(
      "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/UserProfileImageWithUserStatus"
    ).then((mod) => mod.UserProfileImageWithUserStatus),
  {
    ssr: false,
  }
)

const MenuSectionDJUI = dynamic(
  () =>
    import("./components/MenuSectionDJUI").then((mod) => mod.MenuSectionDJUI),
  {
    ssr: false,
  }
)

const MenuLogoutSection = dynamic(
  () =>
    import("./components/MenuLogoutSection").then(
      (mod) => mod.MenuLogoutSection
    ),
  {
    ssr: false,
  }
)

const BASE_TEST_ID = "menu-show-profile-"

export function HeaderButtonProfile() {
  // const userData = await getServerUserData(getServerAppData())
  const userData = useAppStore((state) => state.userData)
  const djUIServerFeatureStatus = getDJUIServerFeatureStatus()

  return (
    <Menu
      width={200}
      position="bottom-end"
      withArrow
      arrowPosition="center"
      offset={3}
    >
      <MenuTarget>
        <BlueButton
          data-testid={`${BASE_TEST_ID}btn-toggle-menu`}
          aria-label="Profile"
          className="!pl-3 !pr-1"
          rightSection={
            <UserProfileImageWithUserStatus
              fullName={userData.user.fullName}
              email={userData.user.email}
            />
          }
        >
          {userData.user.fullName}
        </BlueButton>
      </MenuTarget>
      <MenuDropdown className="!rounded-lg !shadow-lg">
        {djUIServerFeatureStatus !== "disabled" && (
          <>
            <MenuItemToggleDJUIButton />
            <MenuDivider />
          </>
        )}
        <MenuSectionDJUI />
        <MenuLabel>Install</MenuLabel>
        <MenuItemInstallExtensionButton
          id={userData.cluster.chromeExtensionWebstoreId}
        />
        <MenuItemInstallMobileAppButton platform="ios" />
        <MenuItemInstallMobileAppButton platform="android" />
        {/* <MenuLabel>Other Options</MenuLabel> */}
        {/* <MenuItemUserSettingsButton /> */}
        {/* <MenuItemColorSchemeToggle /> */}
        <MenuLogoutSection />
      </MenuDropdown>
    </Menu>
  )
}
